import * as React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import { DashboardLayout } from "./components/dashboard-layout";
import { theme } from "./theme/index";
import CircularProgress from "@mui/material/CircularProgress";
import "./index.css";
import LinearProgress from "@mui/material/LinearProgress";
const App = React.lazy(() => import("./App"));

ReactDOM.render(
  <React.Suspense
    fallback={
      <div
        style={{
          height: "100vh",
          width: "100vw",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <CircularProgress sx={{ color: "#5048E5" }} />
      </div>
    }
  >
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <DashboardLayout>
          <React.Suspense fallback={<LinearProgress />}>
            <App />
          </React.Suspense>
        </DashboardLayout>
      </ThemeProvider>
    </BrowserRouter>
  </React.Suspense>,
  document.getElementById("root")
);
